export const toBooleanValue = (value: unknown, fallback = false): boolean => {
  if (value === null || value === undefined) {
    return fallback
  }

  if (typeof value === 'boolean') {
    return value
  }

  if (typeof value === 'number') {
    return value !== 0
  }

  if (typeof value === 'string') {
    const lowered = value.toLowerCase()
    if (lowered === 'true' || lowered === '1') {
      return true
    }
    if (lowered === 'false' || lowered === '0') {
      return false
    }
  }

  return fallback
}
